// export const API_URL = "https://citizenconsumeraffairs.com/consumer_api2"
// export const API_URL = "https://cdis.iitk.ac.in/consumer_api2"
// export const API_URL = "http://localhost:8000/consumer_api"
// export const API_URL = "https://citizenconsumeraffairs.com/consumer_api"
export const API_URL = "https://citizenconsumeraffairs.com/doca_api"


